/**
 * Row used for promotion item without ticker
 */
import Text from '../../atoms/Text';
import { toFixed2 } from '../DexTrades/formatters';

export interface IPromotedItem {
    id: number
    label: string
    link: string
    price: number
}

interface IProps {
    item: IPromotedItem;
}

const WatchlistRowNotTicker = (props: IProps) => {
  const { item } = props;

  return <a href={item.link} target="_blank" rel="noreferrer" className="watchlist_row">
    <div className="row">
      <div className="left">
        <Text className='watchlist_row__name' size={12}>{item.label}</Text>
      </div>
    </div>
    <div className="right">
      <Text className='watchlist_row__price' size={14}>${toFixed2(item.price)}</Text>
    </div>
  </a>;
};

export default WatchlistRowNotTicker;